var React = require('react');

function Cube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M43.5628 339.409L292.05 410.109C292.712 410.297 293.422 410.216 294.024 409.884L387.186 358.467C387.795 358.131 388.244 357.566 388.434 356.897L458.575 110.375C458.97 108.989 458.166 107.546 456.78 107.152L208.293 36.4516C207.631 36.2632 206.921 36.3441 206.319 36.6767L113.157 88.0936C112.548 88.4296 112.099 88.9948 111.909 89.6637L41.7675 336.186C41.3732 337.571 42.177 339.015 43.5628 339.409Z","fill":"#D94F46"}));
}

Cube.defaultProps = {"width":"0","height":"0","viewBox":"0 0 501 447","fill":"none","id":"cube","className":"shape"};

module.exports = Cube;

Cube.default = Cube;
